import api from "../index";

export const GetAllCountryApi = () => api.get('DropDown/GetAll-Country');